import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { IMeasure } from '../../../../../../model/measure/IMeasure';
import { IParams } from '../../../../../../model/shared/IParams';
import { MEASURE_DOWNLOAD } from '../../../../../../utils/endpoints';
import { CampaignSummarySocialNetworks } from './components/CampaignSummarySocialNetwors';
import { CampaignSummaryTouchpoints } from './components/CampaignSummaryTouchpoints';

import { hasAccessRights } from '../../../../../../shared/functions/Functions';
import { AccessRightEnum } from '../../../../../../enum/AccessRightEnum';
import { useSelector } from 'react-redux';
import { IAllStates } from '../../../../../../store/rootReducer';
import { downloadFileAPI } from '../../../../../../utils';
import { CampaignStatusEnum } from '../../../../../../enum/CampaignStatusEnum';
import { CampaignSummarySocialNetworksSkeleton, CampaignSummaryTouchpointsSkeleton } from './CampaignSummarySkeleton';

interface ICampaignSummaryProps extends Partial<IMeasure> {
    isLoading?: boolean;
}

export const CampaignSummary = ({ platformSummary, campaignSummary, isLoading = false }: ICampaignSummaryProps) => {
    const { t } = useTranslation();
    const { id } = useParams<keyof IParams>();
    const url = `${MEASURE_DOWNLOAD}/${id}`;
    const fileName = `Campaign ${id}`;
    const { campaign } = useSelector((state: IAllStates) => state.selectedCampaign);

    return (
        <>
            <div className="d-flex align-items-center justify-content-between mb-4">
                <h4 className="m-0">
                    {t('brand.campaign.measure.campaignSummary')}: <br className="d-md-none" />{' '}
                    <strong className="text-primary">{campaign?.campaignGoal?.title}</strong>
                </h4>
                {hasAccessRights(AccessRightEnum.CAN_EXPORT_MEASURE) &&
                    campaign?.status !== CampaignStatusEnum.DRAFT && (
                        <Button
                            onClick={() => {
                                downloadFileAPI(url, undefined, fileName);
                            }}
                            className="btn-outline-primary"
                            disabled={isLoading}
                        >
                            {t('brand.campaign.measure.exportExcel')}
                        </Button>
                    )}
            </div>

            {isLoading ? (
                <>
                    <CampaignSummarySocialNetworksSkeleton />
                    <div className="mt-3">
                        <CampaignSummaryTouchpointsSkeleton />
                    </div>
                </>
            ) : (
                <>
                    <CampaignSummarySocialNetworks platformSummary={platformSummary} />
                    <div className="mt-3">
                        <CampaignSummaryTouchpoints campaignSummary={campaignSummary} />
                    </div>
                </>
            )}
        </>
    );
};
